var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23507 23.8822V11.5825L3.42056 8.09279L0 6.15625V21.7116C0 22.9126 0.973057 23.8822 2.17057 23.8822H7.23507Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5991 23.8821H29.6636C30.8647 23.8821 31.8342 22.9089 31.8342 21.7115V6.15625L27.9599 8.37432L24.5991 11.5824V23.8821Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23511 11.5813L6.71606 6.77545L7.23511 2.17578L15.9171 8.68737L24.5992 2.17578L25.1798 6.52712L24.5992 11.5813L15.9171 18.0929L7.23511 11.5813Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5991 2.17662V11.5821L31.8342 6.1559V3.26185C31.8342 0.577703 28.7701 -0.952453 26.6251 0.657288L24.5991 2.17662Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.15596L3.32754 8.65171L7.23507 11.5822V2.17668L5.20912 0.657345C3.06031 -0.95252 0 0.577759 0 3.26178V6.15596Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8342,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.907c1198606e14271743c59d7f35aba7.svg";
export { ForwardRef as ReactComponent };